import React from 'react';
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';
import { Box, FormControlLabel } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
//IDOGAN;449733;25042025
interface ByzMuiCheckBoxProps extends CheckboxProps {
  circular?: boolean;
  text?: string; // Label ekledim
}

export const ByzMuiCheckBox: React.FC<ByzMuiCheckBoxProps> = ({
  circular = false,
  text,
  ...props
}) => {
  if (!circular) {
    return <FormControlLabel control={<Checkbox {...props} />} label={text} />;
  }

  
  const size = 20; 
  const icon = (
    <Box
      sx={{
        width: size,
        height: size,
        border: '2px solid currentColor',
        borderRadius: '50%',
      }}
    />
  );
  const checkedIcon = (
    <Box
      sx={{
        width: size,
        height: size,
        border: '2px solid currentColor',
        borderRadius: '50%',
        bgcolor: 'currentColor',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CheckIcon fontSize="small" sx={{ color: '#fff' }} />
    </Box>
  );

  return (
    <FormControlLabel
      control={
        <Checkbox
          {...props}
          icon={icon}
          checkedIcon={checkedIcon}
        />
      }
      label={text}
    />
  );
};
